// import { Assignee } from "./manageFeedbacksTypes";
//TODO : Translate
export const FEEDBACK_STATUS_LIST = ["Pending", "Processing", "Completed"];
// export const MANUFACTURING_LOCATIONS_LIST = [
//   "Chennai",
//   "Manesar",
//   "Rudrapur",
//   "Imported",
// ];
// export const DEFAULT_SUPPORT_ASSIGNEE_LIST: Assignee[] = [
//   {
//     name: "Chennai Assignee",
//     loginId: "ChennaiAssignee",
//   },
//   {
//     name: "Inadequate request",
//     loginId: "Pankaj",
//   },
//   {
//     name: "Manesar Assignee",
//     loginId: "ManesarAssignee",
//   },
//   {
//     name: "Rudrapur Assignee",
//     loginId: "RudrapurAssignee",
//   },
//   {
//     name: "Value Chain",
//     loginId: "ValueChain",
//   },
// ];
// export const DEFAULT_FEEDBACK_TYPE_LIST : string[] = ["Customer Feedback", "Other Issues"];
